<template>
  <div>
    <span v-if="totalItems">{{$t('global.totalItems')}}: {{totalItems}}</span>
    <b-row>
      <b-col>
        <div v-if="!hasPages(view)">
        </div>
        <nav aria-label="" v-else-if="currentPage === 1 || !hasPages(view)">
          <ul class="pagination pagination-md">
            <li class="page-item"><button class="btn btn-default btn-sm" :disabled="true">
              <i class="fa fa-angle-double-left" aria-hidden="true"></i></button>
            </li>
            <li class="page-item"><button class="btn btn-primary btn-sm ">
              {{checkPage(currentPage)}}</button>
            </li>
            <li class="page-item"><button class="btn btn-default btn-sm " @click="getPage(view['hydra:next'])" :disabled="!nextPage">
              {{checkPage(currentPage) + 1}}</button>
            </li>
            <li class="page-item"><button v-if="hasPageAfterNext()" class="btn btn-default btn-sm" @click="getPage(setPageNum(view['@id'], 3))">
              {{checkPage(currentPage) + 2}}</button>
            </li>
            <li class="page-item"><button class="btn btn-default btn-sm " @click="getPage(view['hydra:last'])" :disabled="!hasPages(view)">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
            </li>
          </ul>
        </nav>
        <!--  jeśli na ostatniej stronie-->
        <nav aria-label="" v-else-if="currentPage === lastPage || !hasPages(view)">
          <ul class="pagination pagination-md">
            <li class="page-item"><button class="btn btn-default btn-sm " @click="getPage(view['hydra:first'])">
              <i class="fa fa-angle-double-left" aria-hidden="true"></i></button>
            </li>
            <li class="page-item"><button class="btn btn-default btn-sm " @click="getPage(setPageNum(view['@id'], lastPage - 2))" v-if="hasPageBeforePrevious()">
              {{previousPage - 1}}</button>
            </li>
            <li class="page-item"><button :disabled="!previousPage" class="btn btn-default btn-sm" @click="getPage(view['hydra:previous'])">
              {{previousPage}}</button>
            </li>
            <li class="page-item"><button class="btn btn-primary btn-sm ">
              {{currentPage}}</button>
            </li>
            <li class="page-item"><button class="btn btn-default btn-sm" :disabled="true">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
            </li>
          </ul>
        </nav>
        <!-- jeśli pomiędzy 1 a ostatnią -->
        <nav aria-label="" v-if="currentPage !== lastPage && currentPage !== 1">
          <ul class="pagination pagination-md">
            <li class="page-item"><button class="btn btn-default btn-sm " @click="getPage(view['hydra:first'])">
              <i class="fa fa-angle-double-left" aria-hidden="true"></i></button>
            </li>
            <li class="page-item"><button :disabled="!previousPage" class="btn btn-default btn-sm" @click="getPage(view['hydra:previous'])">
              {{previousPage}}</button>
            </li>
            <li class="page-item"><button class="btn btn-primary btn-sm disabled">
              {{currentPage}}</button>
            </li>
            <li class="page-item"><button class="btn btn-default btn-sm " @click="getPage(view['hydra:next'])" :disabled="!nextPage">
              {{nextPage}}</button>
            </li>
            <li class="page-item"><button class="btn btn-default btn-sm " @click="getPage(view['hydra:last'])">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
            </li>
          </ul>
        </nav>
      </b-col>
      <b-col>
        <select v-if="hasPages(view) || getItemsPerPageNum() > 10" class="form-control float-right" style="width: 150px; height: 29px" @change="setItemsPerPage($event.target.value)">
          <option disabled :selected="getItemsPerPageNum() === false">{{$t('global.itemsPerPage')}}</option>
          <option :selected="getItemsPerPageNum() === 10" value="10">10</option>
          <option :selected="getItemsPerPageNum() === 25" value="25">25</option>
          <option :selected="getItemsPerPageNum() === 50" value="50">50</option>
          <option :selected="getItemsPerPageNum() === 100" value="100">100</option>
        </select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  computed: {
    currentPage () {
      return this.getPageNum(this.view['@id'])
    },
    previousPage () {
      if (this.view['hydra:previous']) {
        return this.getPageNum(this.view['hydra:previous'])
      } else {
        return false
      }
    },
    nextPage () {
      if (this.view['hydra:next']) {
        return this.getPageNum(this.view['hydra:next'])
      } else {
        return false
      }
    },
    lastPage () {
      if (this.view['hydra:last']) {
        return this.getPageNum(this.view['hydra:last'])
      } else {
        return false
      }
    }
  },
  props: {
    view: {
      required: true
    },
    totalItems: {
      required: false
    }
  },
  methods: {
    checkPage (value) {
      if (!value) {
        return 1
      } else {
        return value
      }
    },
    setItemsPerPage (value) {
      let url = new URL(this.view['@id'], this.$http.defaults.baseURL)
      url.searchParams.set('itemsPerPage', value)
      url = url.href.replace(url.origin, '')
      this.getPage(this.setPageNum(url, 1))
    },
    getItemsPerPageNum () {
      let url = new URL(this.view['@id'], this.$http.defaults.baseURL)
      if (url.searchParams.has('itemsPerPage')) {
        return parseInt(url.searchParams.get('itemsPerPage'))
      } else {
        return false
      }
    },
    hasPages (view) {
      let url = new URL(this.view['@id'], this.$http.defaults.baseURL)
      return url.searchParams.has('_page')
    },
    getPageNum (path) {
      let url = new URL(path, this.$http.defaults.baseURL)
      if (url.searchParams.has('_page')) {
        return parseInt(url.searchParams.get('_page'))
      } else {
        return false
      }
    },
    hasPageBeforePrevious () {
      if (this.lastPage < 3) {
        return false
      } else {
        return true
      }
    },
    hasPageAfterNext () {
      if (this.lastPage <= this.nextPage) {
        return false
      } else {
        return true
      }
    },
    setPageNum (path, page) {
      let url = new URL(path, this.$http.defaults.baseURL)
      url.searchParams.set('_page', page)
      return url.href.replace(url.origin, '')
    },
    getPage (view) {
      this.$emit('getPage', view)
      let pageNumber = view.match('page=([0-9][0-9]?[0-9]?[0-9]?[0-9]?)')
      let itemsPerPage = view.match('itemsPerPage=([0-9][0-9]?[0-9]?[0-9]?[0-9]?)')
      let itemsPerPageCount
      if (itemsPerPage && itemsPerPage.length > 1) {
        itemsPerPageCount = itemsPerPage[1]
      } else {
        itemsPerPageCount = undefined
      }
      this.$emit('getPageNumber', { page: pageNumber[1], itemsPerPage: itemsPerPageCount })
    }
  }
}
</script>
